import React from 'react';

import { HoofdstukElementApiHelper } from '../../../../apiHandlers/HoofdstukElementApiHelper';

export default class LeftSideBarComponent extends React.Component {
  render(){
    let vraag = null;
    if(this.props.selectedVraag !== null){
      vraag = this.props.vragen.byId[this.props.selectedVraag];
    }

    return(
      <div>
        {this.props.selectedVraag !== null ? <div>
          Nieuwe Vraagstelling: <br />
          <textarea
              onChange={(e) => {
                this.props.actions.changeQuestionElement({
                  id: this.props.selectedVraag,
                  alternateQuestion: e.target.value,
                });
              }}
              value={vraag.alternateQuestion}
            />
          <br />
          <button
            onClick={() => {
              HoofdstukElementApiHelper.changeBackOfficeQuestionElement(this.props.vragen.byId[
                this.props.selectedVraag
              ], () => {});
            }}
          >
            Sla op
          </button>
        </div> : <div>Kies een vraag om wijzigingen te maken</div>}
      </div>
    );
  }
}
